// Created by: Imran Khan July 2026
export function parseDashboardFilterParams(search) {
  const params = new URLSearchParams(search || "");
  const from = params.get("from");
  const to = params.get("to");
  const salesExecutive = params.get("salesExecutive");
  const salesExecutiveName = params.get("salesExecutiveName");
  const dateRange = from && to ? [new Date(from), new Date(to)] : [];
  const ownerIds = salesExecutive
    ? [{ value: salesExecutive, label: salesExecutiveName || salesExecutive }]
    : undefined;

  return {
    from,
    to,
    financialYear: params.get("financialYear") || "",
    salesExecutive,
    salesExecutiveName,
    dateRange,
    ownerIds,
    hasLeadStatus: params.has("lead_status"),
    hasVisitStatus: params.has("visit_status"),
    hasOfferStatus: params.has("offer_status"),
    hasOrderStatus: params.has("order_status"),
    leadStatus: params.get("lead_status") || "",
    visitStatus: params.get("visit_status") || "",
    offerStatus: params.get("offer_status") || "",
    orderStatus: params.get("order_status") || "",
  };
}

export function buildDashboardFilterSearch({
  from,
  to,
  financialYear,
  salesExecutive,
  salesExecutiveName,
  extra = {},
}) {
  const params = new URLSearchParams();
  if (from) params.set("from", from);
  if (to) params.set("to", to);
  if (financialYear) params.set("financialYear", financialYear);
  if (salesExecutive) params.set("salesExecutive", salesExecutive);
  if (salesExecutiveName) params.set("salesExecutiveName", salesExecutiveName);

  Object.entries(extra).forEach(([key, value]) => {
    if (value !== undefined && value !== null) params.set(key, value);
  });

  const query = params.toString();
  return query ? `?${query}` : "";
}
